import { Heart } from "lucide-react";
import { ShareButtons } from "@/components/ShareButtons";

const TESTO = "Ti consiglio questo idraulico: pronto intervento H24 in tutta la provincia di Rimini, 30 anni di esperienza. Salvati il numero, non si sa mai!";

export const Consiglia = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="consiglia-section">
    <div className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-10 grid lg:grid-cols-12 gap-6 items-center shadow-sm">
      <div className="lg:col-span-6">
        <p className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-rose-600"><Heart className="w-4 h-4" /> Passaparola</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">Consiglia a un amico o a un vicino</h2>
        <p className="mt-3 text-slate-600">Un guasto può capitare a chiunque, anche di notte. Condividi il nostro numero con famiglia, amici e il gruppo del condominio: lo avranno pronto quando serve.</p>
      </div>
      <div className="lg:col-span-6"><ShareButtons testo={TESTO} idPrefix="consiglia" /></div>
    </div>
  </section>
);
